import classNames from 'classnames';
import InlineSVG from 'svg-inline-react';
import PropTypes from 'prop-types';
import React from 'react';

import Button from '../button/Button';
import warning from '../../assets/images/warning.svg';
import { useAppContext } from '../../common/contexts/AppContext';

const SyncButton = ({ onSync }) => {
    const cssClasses = classNames('dashboard-sync-button');

    const { isUnsyncedData } = useAppContext();

    return (
        <div className='dashboard-sync-button-container'>
            <Button cssClasses={cssClasses} onClick={onSync}>
                <i className='dashboard-sync-button-icon' />
                Sync
            </Button>

            {isUnsyncedData && (
                <div className='dashboard-unsaved-results-warning-container'>
                    <InlineSVG src={warning} className='dashboard-banner-warning-icon' />
                </div>
            )}
        </div>
    );
};

SyncButton.propTypes = {
    onSync: PropTypes.func.isRequired,
};

export default SyncButton;
